import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL_GROUND_CONTROL}`,
  withCredentials: false,
});

export const API = {
  post(endpoint, formData) {
    return instance.post(endpoint, formData);
  },
  put(endpoint, formData) {
    return instance.put(endpoint, formData);
  },
  patch(endpoint, formData) {
    return instance.patch(endpoint, formData);
  },
  get(endpoint, opts = {}) {
    return instance.get(endpoint, opts);
  },
  delete(endpoint) {
    return instance.delete(endpoint);
  },
  registerInterceptor(type, fn) {
    if (type === 'REQUEST') {
      instance.interceptors.request.use(fn, err => Promise.reject(err));
    } else if (type === 'RESPONSE') {
      instance.interceptors.response.use(fn, err => Promise.reject(err));
    }
  },
};

export const ENDPOINTS = {
  // GET Endpoints
  GET_STRIPE_PK: '/stripekey',
  GET_INTEGRATION_API_KEY: '/apikey/integration',
  GET_BGL_ACCESS_TOKEN: '/borg/access',
  GET_INTEGRATION_REFRESH_TOKEN: '/borg/refresh',
  GET_OAUTH_AUTHORISE: '/oauth/authorise',
  GET_OAUTH_TOKEN: '/oauth/token',
  GET_ACCOUNTS: '/account',
  GET_ACCOUNTUSER: '/accountuser',
  GET_APP_PERMISSIONS: '/apppermission',
  GET_INVITATIONS: '/invitations',
  GET_TOOLKIT_ITEM: '/toolkit',
  GET_TOOLKIT_ITEMS: '/toolkit',
  GET_PENSION_ESTABLISHMENT: '/toolkit',
  GET_SHARES: '/share',
  GET_SHARE_USERS: '/shares',
  GET_SHARE_INVESTMENT_STRATEGIES: '/share/investment_strategy',
  GET_APP_PLANS: '/plans',
  GET_APP_PRICES: '/prices',
  GET_STRIPE_INVOICE: '/invoice',
  GET_STRIPE_PAYMENT_METHOD: '/paymentmethod',
  GET_STRIPE_SUBSCRIPTION: '/subscriptions',
  // POST Endpoints
  POST_ADMIN_USERINFO: '/userinfo',
  POST_ACCOUNT: '/account',
  POST_ACTIVATE: '/activate',
  POST_UPDATE_INVITE: '/invite/update',
  POST_INVITE: '/invite',
  POST_REVOKE_INVITE: '/invite/revoke',
  POST_ACCOUNTUSER: '/accountuser',
  POST_APP_PERMISSIONS: '/apppermissions/update',
  POST_INTEGRATION_GET_FUNDS: '/borg/fund',
  POST_NOTIFICATION: '/notification',
  POST_USEREXISTS: '/userexists',
  POST_USEREMAILSTATUS: '/useremailstatus',
  POST_FEEDBACK: '/feedback',
  POST_SHARE: '/share',
  POST_PAYMENT_INTENT: '/create-payment-intent',
  POST_PURCHASE: '/purchase',
  POST_SUBSCRIBE: '/subscribe',
  POST_SUBSCRIPTION: '/subscription',
  POST_STRIPE_INVOICE: '/invoice',
  POST_PENSION_ESTABLISHMENT: '/toolkit',
  POST_TOOLKIT: '/toolkit',
  POST_RENDER_PDF: '/pdf',
  POST_RENDER_DOCX: '/docx',
  // PATCH Endpoints
  PATCH_ACCESS_TOKEN: '/accountuser',
  PATCH_SHARE: '/share',
  // DELETE Endpoints
  DELETE_SHARE: '/share',
  DELETE_ACCOUNT_USER: '/account',
  DELETE_TOOLKIT_ITEM: '/toolkit',
};
